
    import './styles.scoped.css';
    export default {
  "icon-shake": "awsui_icon-shake_1cbgc_1soq2_149",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_1soq2_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_1soq2_177",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_1soq2_1",
  "root": "awsui_root_1cbgc_1soq2_199",
  "status-error": "awsui_status-error_1cbgc_1soq2_208",
  "status-warning": "awsui_status-warning_1cbgc_1soq2_211",
  "status-success": "awsui_status-success_1cbgc_1soq2_214",
  "status-info": "awsui_status-info_1cbgc_1soq2_217",
  "status-stopped": "awsui_status-stopped_1cbgc_1soq2_220",
  "status-pending": "awsui_status-pending_1cbgc_1soq2_223",
  "status-in-progress": "awsui_status-in-progress_1cbgc_1soq2_226",
  "status-loading": "awsui_status-loading_1cbgc_1soq2_229",
  "status-not-started": "awsui_status-not-started_1cbgc_1soq2_232",
  "status-log": "awsui_status-log_1cbgc_1soq2_235",
  "color-override-red": "awsui_color-override-red_1cbgc_1soq2_238",
  "color-override-grey": "awsui_color-override-grey_1cbgc_1soq2_241",
  "color-override-blue": "awsui_color-override-blue_1cbgc_1soq2_244",
  "color-override-green": "awsui_color-override-green_1cbgc_1soq2_247",
  "color-override-yellow": "awsui_color-override-yellow_1cbgc_1soq2_250",
  "container": "awsui_container_1cbgc_1soq2_177",
  "display-inline": "awsui_display-inline_1cbgc_1soq2_306",
  "icon": "awsui_icon_1cbgc_1soq2_149",
  "display-inline-block": "awsui_display-inline-block_1cbgc_1soq2_314",
  "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_1soq2_323"
};
  